import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ICON_SIZE = 24;

const sizePropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

function BusIcon({ w, h, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M5.333 14.667h13.333v-6c0-.737-.597-1.334-1.333-1.334H6.666c-.736 0-1.333.597-1.333 1.334v6zm12 1.333a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667zM6.666 16a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667zM20 14.667v6.666a.667.667 0 01-.667.667H18a.666.666 0 01-.667-.667V20H6.666v1.333A.666.666 0 016 22H4.666A.666.666 0 014 21.333v-6.666H3A.667.667 0 012.333 14v-2.667c0-.368.298-.666.667-.666h1V8.94C4 5.118 8.333 4 12 4c4.051 0 8 1.118 8 4.941v1.726h1c.368 0 .666.298.666.666V14a.667.667 0 01-.666.667h-1z" />
    </svg>
  );
}

BusIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

BusIcon.propTypes = {
  w: sizePropType,
  h: sizePropType,
  className: PropTypes.string,
};

BusIcon.defaultProps = {
  w: DEFAULT_ICON_SIZE,
  h: DEFAULT_ICON_SIZE,
  className: '',
};

export default BusIcon;
